<template>
    <div class="select-box">
        <div class="header">
            <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全部{{proName}}分类</el-checkbox>
        </div>
        <div class="content clearfix">
            <el-checkbox-group v-model="checkedCategory" @change="handleCheckedCategoryChange">
                <div class="check-item" v-for="cate in categoryListData">
                    <el-checkbox :label="cate.id" :key="cate.id" :disabled="checkDisabled(cate.id)">{{cate.name}}</el-checkbox>
                </div>
            </el-checkbox-group>
        </div>
        <div class="foot">
            <el-button size="small" @click="cancelSave">&nbsp;&nbsp;取消&nbsp;&nbsp;</el-button>&nbsp;&nbsp;&nbsp;&nbsp;
            <el-button size="small" type="primary" @click="submitSave">&nbsp;&nbsp;确定&nbsp;&nbsp;</el-button>
        </div>
    </div>
</template>

<script>
    import obj from "@/js/obj";
    export default {
        name: "SelectCategory",
        props: {
            selectedData: {
                type: Array,
                default: []
            },
            proType: {
                type: Number,
                default: 0
            }
        },
        data: () => ({
            proName: "",
            isIndeterminate: false,
            checkAll: false,
            categoryListData: [],
            checkedCategory: [],        //已选中的分类
            disabledCategory: [],       //禁选的分类ID集合
        }),
        mounted: function () {
            this.initData();
        },
        methods: {
            initData: function () {
                if(this.proType === 1) {
                    this.proName = "项目";
                }else if(this.proType === 2) {
                    this.proName = "产品";
                }else if(this.proType === 5) {
                    this.proName = "卡项";
                }else{
                    this.proName = "";
                    return false;
                }
                this.loadListData();
            },
            //选中所有状态改变
            handleCheckAllChange: function (data) {
                if(data){
                    let checkId = [];
                    this.categoryListData.forEach((val, i) => {
                        if(!obj.inArray(val.id, this.disabledCategory))
                            checkId.push(val.id);
                    });
                    this.checkedCategory = checkId;
                }else{
                    this.checkedCategory = [];
                }
            },
            //选择的分类发生改变
            handleCheckedCategoryChange: function (data) {
                if(data.length === this.categoryListData.length)
                    this.checkAll = true;
                else
                    this.checkAll = false;
            },
            //加载分类数据
            loadListData: function (data) {
                obj.postData("store_vip/get_product_category", {pro_type: this.proType}, res => {
                    this.categoryListData = res.data;
                });
            },
            //取消
            cancelSave: function () {
                this.$emit("cancel");
            },
            //确定
            submitSave: function () {
                let result = [];
                this.checkedCategory.forEach(v => {
                    if(!obj.inArray(v, this.disabledCategory))
                        result.push(v);
                });
                this.$emit("done", result);
            },
            //判断是否禁用
            checkDisabled: function (cid) {
                if(obj.inArray(cid, this.disabledCategory))
                    return true;
                else
                    return false;
            }
        },
        watch: {
            selectedData: function (data) {
                this.disabledCategory = data;

                //更新选择
                let newSelectIdArr = [];
                this.checkedCategory.forEach((cid, key) => {
                   if(!obj.inArray(cid, data))
                       newSelectIdArr.push(cid);
                });
                this.checkedCategory = newSelectIdArr;
            },
            proType: function () {
                this.initData();
            }
        }
    }
</script>

<style scoped>
    .header{
        height: 50px;
        padding: 0 16px;
        line-height: 50px;
        background: #f9f9f9;
    }
    .content{
        height: 170px;
        padding: 0 16px;
        overflow: auto;
    }
    .foot{
        height: 60px;
        line-height: 60px;
        text-align: center;
        border-top: 1px solid #ddd;
    }
    .check-item{
        height: 30px;
        width: 33%;
        margin: 5px 0;
        line-height: 30px;
        float: left;
    }
</style>
